const {KitModule, registerModule} = window;

/**
 * Home hero background clip. The first-frame still sits under the <video>;
 * when the clip can't play (a source fails to load, iOS Low Power Mode
 * refuses autoplay, or the visitor prefers reduced motion) the clip is
 * hidden so only the still shows — never a paused frame or the native play
 * glyph iOS draws over a video it won't start.
 */
class HeroVideo extends KitModule {
    onInitialize() {
        if (!this.$video) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.$video.pause();
            this.showStill();
            return;
        }

        // Error on the last <source> means every candidate failed.
        const $sources = this.$video.querySelectorAll('source');
        $sources[$sources.length - 1]?.addEventListener('error', () => this.showStill());
        this.$video.addEventListener('error', () => this.showStill());

        if (this.$video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) {
            this.showStill();
            return;
        }

        // Autoplay may already be running; play() is a no-op then. A refusal
        // (NotAllowedError in Low Power Mode) or no playable source
        // (NotSupportedError) rejects; an AbortError is just an interrupted
        // load that autoplay retries on its own.
        this.$video.play()?.catch((error) => {
            if (error?.name !== 'AbortError') this.showStill();
        });
    }

    showStill() {
        this.$element.classList.add('hero--video-still');
    }
}

registerModule('heroVideo', HeroVideo);
